'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./search/search'));
    processInclude(require('./product/quickView'));

    if (window.resources.preferences.subscriptionProvider == 'ordergroove' && window.OG) {
        processInclude(require('orderGroove/product/quickView'));
    }
});
